import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Isvg from 'react-inlinesvg'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import interactiveVideoActions from 'redux/actions/interactiveVideoActions'
import { localize } from 'helpers/translator'
import Modalizer from 'components/modalizer/modalizer'
import OverlayNotification from 'components/overlay_notification/overlay_notification'

import scissors from 'assets/views/interactive_video/editor/scissors.svg'

const scissorsIcon = <Isvg src={scissors} cacheGetRequests={true} />

const InteractiveVideoTrimChangeNotSavedContainer = props => (
	<Modalizer
		closeButton={false}
		noPadding
		boxed={false}
	>
		<OverlayNotification
			color='blue'
			transparent={true}
			icon={scissorsIcon}
			text={localize('interactive_video_trimtool_save_modal_title')}
			btTwo={localize('interactive_video_trimtool_save_modal_trimAndSave')}
			btOne={localize('interactive_video_trimtool_save_modal_goBack')}
			actionTwo={props.actions.trimAndSave}
			actionOne={props.actions.goBack}
		/>
	</Modalizer>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		trimAndSave: interactiveVideoActions.trimToolUnsavedTrimAndSave,
		goBack: interactiveVideoActions.trimToolUnsavedBack,
	}, dispatch)
}

InteractiveVideoTrimChangeNotSavedContainer.propTypes = {
	actions: PropTypes.shape({
		trimAndSave: PropTypes.func.isRequired,
		goBack: PropTypes.func.isRequired,
	}),
}

export default connect(null, mapDispatchToProps)(InteractiveVideoTrimChangeNotSavedContainer)

export { InteractiveVideoTrimChangeNotSavedContainer }
